// extracted by mini-css-extract-plugin
export var main = "Web-module--main--43CfC";